document.addEventListener('alpine:init', () => {
  Alpine.data('SubscriptionWidget', () => ({
    product: null,
    selected_variant: null,
    mf_weight: '',
    mf_per_bath: '',
    price_per_bottle_regular: '',
    price_per_bath: '',
    selling_plans: [],
    selected: {
      type: 'subscribe', // 'one-time' or 'subscribe'
      frequency: '',
      plan: null,
      quantity: 1
    },
    init() {
      this.InitWatchers();
      this.InitSelf();
    },
    InitSelf() {
      let product = JSON.parse(this.$el.dataset.product);
      this.product = product;
      // console.log(product);
      this.selected_variant = JSON.parse(this.$el.dataset.selected_variant);
      let selling_plans = this.selected_variant.selling_plan_allocations.map(item => {
        let plan = this.product.selling_plan_groups[0].selling_plans.find(plan => plan.id == item.selling_plan_id);
        return { ...item, ...plan };
      });

      this.selling_plans = selling_plans;
      this.selected.plan = selling_plans[this.$el.dataset.selected_frequency_index] || selling_plans[0];
      this.selected.frequency = this.selected.plan.selling_plan_id;

      if (this.product.selling_plan_groups.length > 0) {
        this.subscription_discount = this.product.selling_plan_groups[0].selling_plans[0].price_adjustments[0].value;
      }

      this.mf_weight = parseFloat(this.$el.dataset.mf_weight);
      this.mf_per_bath = parseFloat(this.$el.dataset.mf_per_bath);
      this.mf_bottles = parseInt(this.$el.dataset.mf_bottles);
      this.price_per_bottle_regular = parseFloat(this.$el.dataset.mf_per_bottle_price);
    },
    InitWatchers() {
      let $product = this.$el.closest('.product__info-container');
      let $quantity = $product.querySelector('[name=quantity]');
      if ($quantity) {
        $quantity.addEventListener('change', (e) => {
          this.selected.quantity = parseInt(e.target.value);
        });
      }

      this.$watch('selected.frequency', () => {
        let plan = this.selling_plans.find(plan => plan.selling_plan_id == this.selected.frequency);
        this.selected.plan = plan;
      });

      this.$watch('selected', () => {
        document.dispatchEvent(new CustomEvent('sticky-atc:update', { detail: { selected: this.selected, selected_variant: this.selected_variant } }));
      });
    },
    u_GetPricePerBath(selected_type) {
      let price = selected_type === 'subscribe' ? this.selected.plan.per_delivery_price : this.selected_variant.price;
      let per_bath = (price / this.mf_weight) / this.mf_per_bath;
      return per_bath;
    },
    u_GetPricePerBottle(selected_type) {
      let price = selected_type === 'subscribe' ? this.selected.plan.per_delivery_price : this.selected_variant.price;
      let bottles_count = this.mf_bottles;
      let per_bottle = (price / bottles_count) / 100;
      let per_bottle_regular = this.price_per_bottle_regular / 100;
      let saving = per_bottle_regular - per_bottle;
      return  selected_type === 'subscribe' ? saving: per_bottle;
    },
    u_FormatMoney(value) {
      return formatMoney(value, theme.settings.money_with_currency_format);
    },
    e_HandleFrequencyChange(e) {
      // console.log('e_handleFrequencyChange', e);
      let plan = this.selling_plans.find(plan => plan.selling_plan_id == e.target.value);
      this.selected.plan = plan;
    }
  }));

  Alpine.data('ProductMediaGallery', () => ({
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
        let variant = e.data.variant;
        this.LoadVariantImages(variant);
      });
    },
    async LoadVariantImages(variant) {
      if (!variant) return;
      let section_id = this.$el.dataset.section_id;
      let url = `${window.location.pathname}?variant=${variant.id}&section_id=${section_id}`;
      let response = await fetch(url);
      let data = await response.text();
      let html = new DOMParser().parseFromString(data, 'text/html');
      let $gallery = html.querySelector('media-gallery gallery-carousel');
      if ($gallery) {
        // Replace the current gallery with the new one
        this.$el.querySelector('gallery-carousel').replaceWith($gallery);
        document.dispatchEvent(new Event('gallery:refresh'));
      }
    }
  }));

  Alpine.data('BundleSticky', () => ({
    opened: false,

    toggleSticky() {
      this.opened = !this.opened;
    }
  }));

  Alpine.data('BundleSubscription', () => ({
    showModal: false,

    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    handleBackdropClick(event) {
      if (!this.$refs.modalContent.contains(event.target)) {
        this.closeModal();
      }
    },
  }));

  Alpine.data('VariantInfo', () => ({
    showModal: false,

    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    handleBackdropClick(event) {
      if (!this.$refs.modalContent.contains(event.target)) {
        this.closeModal();
      }
    },
  }));

  Alpine.data('BundleProductMedia', () => ({
    showAlter: false,

    showAlterImage() {
      this.showAlter = true;
    },
    hideAlterImage() {
      this.showAlter = false;
    }
  }));

  Alpine.data('BundleBuilder', () => ({
    product: null,
    selected_variants: [],
    total_price: 0,
    min_quantity: 3,
    bundle_price: 0,
    bundle_quantity: 0,
    bundle_discount: 10, // Assuming a fixed 10% discount for the bundle
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      this.$watch('selected_variants', () => {
        // Update total quantity and price whenever selected_variants changes
        let total_quantity = this.selected_variants.reduce((total, variant) => {
          return total + variant.quantity;
        }, 0);
        this.bundle_quantity = total_quantity;

        let total_price = this.selected_variants.reduce((total, variant) => {
          return total + (variant.price * variant.quantity);
        }, 0);
        this.total_price = total_price;
        this.bundle_price = total_price * (1 - this.bundle_discount / 100);
      });
    },
    e_UpdateBundleVariants(e) {
      this.$nextTick(() => {
        let $variant = this.$el;
        let variant = JSON.parse($variant.dataset.variant);
        variant.quantity = parseInt($variant.querySelector('.stay-ai-bundle-product__quantity-display').textContent);

        let variant_exists = this.selected_variants.find(v => v.id === variant.id);
        if (variant_exists) {
          // If variant already exists, update its quantity
          variant_exists.quantity = variant.quantity;
        } 
        else {
          // If variant does not exist, add it to the array
          this.selected_variants.push(variant);
        }
      });
    },
    u_FormatMoney(value) {
      return formatMoney(value, theme.settings.money_with_currency_format);
    }
  }));

  Alpine.data('StickyAddToCart', () => ({
    selected_variant: null,
    selected: {
      type: 'subscribe', // 'one-time' or 'subscribe'
      frequency: '',
      plan: null,
      quantity: 1
    },
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      document.addEventListener('sticky-atc:update', (e) => {
        let is_subscribe = e.detail.selected.type === 'subscribe';
        // console.log('sticky-atc:update', e);
        this.selected = { ...e.detail.selected };
        this.selected_variant = { ...e.detail.selected_variant };
        
        // update price
        this.$nextTick(() => {
          let price_element = this.$el.querySelector('.price__container');
          console.log('price_element', price_element);
          if (price_element) {
            if (is_subscribe) {
              price_element.innerHTML = `<span class="tw:line-through tw:mr-2 tw:text-[#F65275]">${this.u_FormatMoney(this.selected_variant.price)}</span> <span class="tw:font-bold">${this.u_FormatMoney(this.selected.plan?.per_delivery_price)}</span>`;
            }
            else {
              price_element.innerHTML = `<span class="tw:font-bold">${this.u_FormatMoney(this.selected_variant.price)}</span>`;
            }
          }
        });
      });
    },
    u_FormatMoney(value) {
      return formatMoney(value, theme.settings.money_with_currency_format);
    }
  }));
});